import React, { Component } from 'react';
import commonUtil from '../../../../../../../utils/commonUtil';

import serverClientUtil from '../../../../../../../utils/serverClientUtil';
import Link from '../../../../../../../components/ZUILib/Link';

class OrderInfo extends Component {
  render() {
    const { trackingUrl, pedidoNumber, lables } = this.props;

    let trackUrl = trackingUrl;
    if (trackUrl === 'adminpage.regalodelevento.order.redirect.url') {
      trackUrl = '';
    }

    return (
      <div className='order-container'>
        <div className='order-inner'>
          <div className='order-row'>
            <div className='order-text'>
              {commonUtil.getLabel(
                lables.EventAdminPage,
                'adminpage.regalodelevento.event.order.number.label',
              )}{' '}
              {pedidoNumber}
            </div>
          </div>
        </div>

        <div className='order-status-row'>
          <div className={`order-status${!trackUrl ? ' order-status-disabled' : ''}`}>
            <Link
              isNotSamePage
              linkJSON={{
                href: trackUrl
                  ? serverClientUtil.getLPURL() + trackUrl + pedidoNumber
                  : 'javascript:void(0)',
                id: pedidoNumber,
                cssClass: !trackUrl ? 'order-disabled-link' : '',
              }}
            >
              {commonUtil.getLabel(
                lables.EventAdminPage,
                'adminpage.regalosrecibidos.trackorder.label',
              )}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderInfo;
